export const feed = state => state.feed;
export const newPostNumber = state => state.newPostNumber;
export const feedLoading = state => state.feedLoading;
export const nextPostsLoading = state => state.nextPostsLoading;
export const error = state => state.error;
